import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

const main = `${BASE_URL}api/closing_file/`;

export const CLOSING_FILE_ENDPOINTS = {
  main,
  export_main: `${main}export_meta`,
  synthese: (entityId) => `${main}${entityId}/synthese`,
  synchronize: (quarter_name) => `${main}${quarter_name}/synchronize`,
  notes: (entityId, testId) => `${main}${entityId}/${testId}/notes`,
  results: (entityId, testId) => `${main}${entityId}/${testId}/results`,
};

class ClosingFile {
  async synchronize(quarter_name) {
    let quarter = await this.getQuarter(quarter_name)
    let is_plaquette = quarter.is_plaquette
    const { data } = await request({
      url: CLOSING_FILE_ENDPOINTS.synchronize(quarter_name),
      query: { is_plaquette }
    })
    return data
  }

  async getAvailableTests() {
    const { data } = await request({ url: CLOSING_FILE_ENDPOINTS.main });
    return data;
  }

  async getQuarters() {
    const { data } = await request({ url: `${CLOSING_FILE_ENDPOINTS.main}quarters` });
    return data;
  }

  async getQuarter(quarter_name) {
    const { data } = await request({
      url: `${CLOSING_FILE_ENDPOINTS.main}quarter`,
      query: {
        quarter_name: quarter_name
      }
    });
    return data;
  }

  async getNotes(entityId, testId, quarter_name) {
    const { data } = await request({ url: CLOSING_FILE_ENDPOINTS.notes(entityId, testId), query: {quarter_name} });
    return data;
  }

  async saveNote(noteData, shouldDelete=false) {
    const { data } = await request({
      url: CLOSING_FILE_ENDPOINTS.notes(noteData.entity_id, noteData.test_id),
      method: shouldDelete ? 'DELETE' : noteData.note_id ? 'PUT' : 'POST',
      body: noteData
    });
    return data
  }

  async getMeta(quarter_name){
    const { data } = await request({
      url: `${CLOSING_FILE_ENDPOINTS.main}meta`,
      query: {quarter_name}
    });
    return data
  }

  async getTestTables(testId, entityId, quarter_name){
    const { data } = await request({
      url: CLOSING_FILE_ENDPOINTS.results(entityId, testId, quarter_name),
      query: {quarter_name}
    });

    return data
  }

  async updateManualControl(row, testId, entityId, quarter_name, tableName){
    const {data} = await request({
      url: `${CLOSING_FILE_ENDPOINTS.results(entityId, testId)}/manual-control`,
      query: {quarter_name, table_name: tableName},
      body: {updated_row: row},
      method: "PUT"
    });
    return data
  }

  async getManualControl(testId, entityId, quarter_name){
    const {data} = await request({
      url: `${CLOSING_FILE_ENDPOINTS.results(entityId, testId)}/manual-control`,
      query: {quarter_name},
    });
    return data
  }

  async downloadWithComments(testId, entityId, quarter_name, filename, export_columns){
    return await request({
      url: `${CLOSING_FILE_ENDPOINTS.results(entityId, testId)}/${filename}/export`,
      query: {quarter_name},
      method: "POST",
      body: {
        export_columns: export_columns
      }
    });
  }

  async setResultControlPassed(testId, entityId, quarter_name, controlPassed=false){
    const { data } = await request({
      url: CLOSING_FILE_ENDPOINTS.results(entityId, testId),
      query: {quarter_name, control_passed: controlPassed},
      method: "PUT"
    });

    return data
  }

  async getSyntheseTable(entityId, quarter_name){
    const { data } = await request({url: CLOSING_FILE_ENDPOINTS.synthese(entityId), query: {quarter_name}});
    return data
  }

  async runQuarterCalculation(quarter_name) {
    let quarter = await this.getQuarter(quarter_name)
    let is_plaquette = quarter.is_plaquette
    const { data } = await request({
      url: `${CLOSING_FILE_ENDPOINTS.main}calculate`,
      method: "POST",
      query: {
        quarter_name,
        is_plaquette
      }
    });
    return data;
  }

  async runEntityCalculations(entityId, quarter_name) {
    let quarter = await this.getQuarter(quarter_name)
    let is_plaquette = quarter.is_plaquette
    const { data } = await request({
      url: `${CLOSING_FILE_ENDPOINTS.main}${entityId}/calculate`,
      method: "POST",
      query: {
        quarter_name,
        is_plaquette
      }
    });
    return data;
  }

  async getTableColumnsSum(tableName, columns) {
    const {data} = await request({
      url: `${CLOSING_FILE_ENDPOINTS.main}columns-sum`,
      method: "POST",
      query: {
        table_name: tableName,
      },
      body: {
        columns
      }
    });
    return data;
  }
}

export const ClosingFileService = new ClosingFile();
